define('helperEntity-isQuizGamePage',[],function() {
    'use strict';

    var isQuizGamePage = function(entity) {
        var i = 0,
            componentsJSON;

        if (!entity || !entity.hasOwnProperty('contentEntity')) {
            return;
        }

        componentsJSON = (entity.contentEntity.componentsJson) ? JSON.parse(entity.contentEntity.componentsJson) : [];

        i = componentsJSON.length;

        while(i--) {
            if (componentsJSON[i].hasOwnProperty('kind') && componentsJSON[i].kind && componentsJSON[i].kind.toLowerCase() === 'quizgame' && componentsJSON[i].hasOwnProperty('content')) {
                return true;
            }
        }

        return false;
    };

    return isQuizGamePage;
});

